/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconAlertFilled16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconAlertFilled16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.296 2.015.251 12.071C-.48 13.385.472 15 1.977 15h12.046c1.505 0 2.457-1.615 1.726-2.93L9.748 2.015c-.752-1.354-2.7-1.353-3.452 0Zm1.728 8.554c-.692 0-1.217.499-1.217 1.215 0 .716.525 1.215 1.217 1.215.691 0 1.216-.499 1.216-1.215 0-.716-.525-1.215-1.216-1.215Zm.449-6.057h-.9a.8.8 0 0 0-.796.88l.398 3.747c.027.272.257.48.53.48h.636a.533.533 0 0 0 .53-.48L9.27 5.39a.8.8 0 0 0-.796-.879Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconAlertFilled24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconAlertFilled24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.566 2.303c-1.047.462-1.849 1.84-3.453 4.597l-3.316 5.7c-1.603 2.757-2.405 4.135-2.285 5.266a3.495 3.495 0 0 0 1.434 2.466C3.873 21 5.476 21 8.684 21h6.632c3.207 0 4.81 0 5.738-.668a3.495 3.495 0 0 0 1.434-2.466c.12-1.131-.682-2.51-2.285-5.266l-3.316-5.7c-1.604-2.757-2.406-4.135-3.453-4.597a3.551 3.551 0 0 0-2.868 0ZM12 15c-.699 0-1.252.52-1.252 1.243 0 .722.553 1.257 1.252 1.257.713 0 1.267-.535 1.267-1.257C13.267 15.52 12.714 15 12 15Zm-1.186-6.978a.502.502 0 0 1 .503-.522h1.366c.287 0 .516.237.503.522l-.308 5a.502.502 0 0 1-.504.478h-.748a.502.502 0 0 1-.503-.478l-.31-5Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconAlertFilled = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconAlertFilled(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconAlertFilled16 {...iconProps} />;
        case '24':
            return <IconAlertFilled24 {...iconProps} />;
        default:
            return <IconAlertFilled24 {...iconProps} />;
    }
});
